module.exports = "/static/assets/05049991b8bdd02953cb06416819b07b.png";